import { DeleteRounded, MoreVertOutlined, Payment } from '@mui/icons-material'
import { Box, Chip, IconButton, Menu, MenuItem, TableCell, TableRow, Typography } from '@mui/material'
import moment from 'moment'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { ModalIdentifiers } from 'src/constants/modal'
import { useAppDispatch, useAppSelector } from 'src/redux_store'
import { openModal } from 'src/redux_store/common/modal/modal_slice'
import { Subscription, SubscriptionItemStatuses } from 'src/types'
import DeleteSubscriptionModal from '../delete_subscirption_modal'
import { getSubscriptionPlan } from '../../../utils'
import { useTranslation } from 'react-i18next'
// import SubscriptionPaymentModal from '../subscription_payment_modal'

const UnpaidSubscriptionRow = ({ subscription, orgId }: { orgId: string; subscription: Subscription }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  //   const dispatch = useAppDispatch()

  const { subscriptionPlans } = useAppSelector((state) => state.organizations)

  //   const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  //   const open = Boolean(anchorEl)

  //   const handleClick = (event: React.MouseEvent<HTMLElement>) => {
  //     event.preventDefault()
  //     event.stopPropagation()
  //     setAnchorEl(event.currentTarget)
  //   }

  const handleCellClick = () => {
    navigate(subscription.id)
  }

  //   const handleClose = () => {
  //     setAnchorEl(null)
  //   }

  //   const handlePayment = () => {
  //     handleClose()
  //     dispatch(
  //       openModal({
  //         modalId: ModalIdentifiers.SUBSCRIPTION_PAYMENT,
  //         dialogComponent: <SubscriptionPaymentModal orgId={orgId} subscription={subscription} />,
  //       })
  //     )
  //   }

  //   const handleDelete = () => {
  //     handleClose()
  //     dispatch(
  //       openModal({
  //         modalId: ModalIdentifiers.DELETE_SUBSCRIPTION,
  //         dialogComponent: <DeleteSubscriptionModal orgId={orgId} subscription={subscription} />,
  //       })
  //     )
  //   }

  const subPlan = getSubscriptionPlan(subscriptionPlans, subscription.items?.[0]?.subscriptionPlanId)

  if (!subPlan) return

  return (
    <TableRow sx={{ cursor: 'pointer' }}>
      <TableCell onClick={handleCellClick}>
        <Chip label={subPlan.plan.name} size="small" variant="outlined" />
      </TableCell>
      <TableCell onClick={handleCellClick}>
        <Typography>{subscription.metadata['stations']}</Typography>
      </TableCell>
      <TableCell onClick={handleCellClick}>
        {subPlan.interval === 1 && <Chip label={t('subscription.Month')} size="small" variant="outlined" />}
        {subPlan.interval === 2 && <Chip label={t('subscription.Year')} size="small" variant="outlined" />}
      </TableCell>
      <TableCell onClick={handleCellClick}>
        <Typography>{moment(subscription.createdAt).format('HH:mm:ss DD-MM-YYYY')}</Typography>
      </TableCell>
      <TableCell onClick={handleCellClick}>
        <Typography>
          {subscription.currentPeriodEnd ? moment(subscription.currentPeriodEnd).format('HH:mm:ss DD-MM-YYYY') : ''}
        </Typography>
      </TableCell>
      <TableCell onClick={handleCellClick}>
        {/* <Chip label="Unpaid" size="small" color="warning" /> */}
        {subscription.currentPeriodEnd && new Date(subscription.currentPeriodEnd) < new Date() && (
          <Chip label="Expired" size="small" color="error" />
        )}
        {subscription.items.length === 1 && subscription.items[0].status === SubscriptionItemStatuses.UNPAID && (
          <Chip label="Unpaid" size="small" color="warning" />
        )}
        {!!subscription.items.length && subscription.items[0].status === SubscriptionItemStatuses.IN_SERIVCE && (
          <Chip label="Active" size="small" color="success" />
        )}
      </TableCell>
      {/* <TableCell component={'div'}>
        <IconButton onClick={handleClick}>
          <MoreVertOutlined />
        </IconButton>
        <Menu
          id="unpaid-subscriptions-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          disablePortal
          elevation={1}
          sx={{ minWidth: 480 }}
        >
          <MenuItem sx={{ width: 150 }} onClick={handlePayment}>
            <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} flex={1}>
              <Typography>Payment</Typography>
              <Payment />
            </Box>
          </MenuItem>
          <MenuItem sx={{ width: 150 }} onClick={handleDelete}>
            <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} flex={1}>
              <Typography>Delete</Typography>
              <DeleteRounded />
            </Box>
          </MenuItem>
        </Menu>
      </TableCell> */}
    </TableRow>
  )
}

export default UnpaidSubscriptionRow
